import React from "react";

import { SubmitButton } from "../../components/inputs";
import { WizardProgress } from "./index.jsx";

const FormFooter = ({
  step,
  isSubmitting,
  goBack,
  onCancel,
  isMerchantClient,
}) => {
  const stepCount = 2;

  let label = "";
  if (isMerchantClient && step === stepCount) {
    label = "Confirm";
  } else {
    label = step === stepCount ? "Validate Account" : "Next";
  }

  return (
    <div className="action-row">
      <div className="wizard-progress-row">
        <WizardProgress step={step} stepCount={stepCount} />
      </div>
      <div className="wizard-buttons">
        {step > 1 && goBack && (
          <SubmitButton className="mr-2" variant="secondary" label="Back" onClick={goBack} />
        )}
        {step == 1 && onCancel && (
          <SubmitButton className="mr-2" variant="secondary" label="Cancel" onClick={onCancel} />
        )}
        <SubmitButton isSubmitting={isSubmitting} label={label} />
      </div>
    </div>
  );
};

export default FormFooter;
